@if (loading()) {
  <div class="eventq-site-fields eventq-site-fields__skeleton" aria-hidden="true">
    <div
      class="eventq-site-fields__skeleton-grid"
      [class.eventq-site-fields__skeleton-grid--stacked]="stacked()"
    >
      @for (row of [1, 2, 3, 4, 5, 6]; track row) {
        <div class="eventq-site-fields__skeleton-field">
          <div class="eventq-site-fields__skeleton-block eventq-site-fields__skeleton-block--label"></div>
          <div class="eventq-site-fields__skeleton-block eventq-site-fields__skeleton-block--value"></div>
        </div>
      }
    </div>
  </div>
} @else if (hasContent()) {
  <div class="eventq-site-fields" [class.eventq-site-fields--stacked]="stacked()">
    <div class="eventq-site-fields__grid" [class.eventq-site-fields__grid--stacked]="stacked()">
      @for (field of fields(); track field.id) {
        <div class="eventq-site-fields__field">
          <p class="eventq-site-fields__label">{{ field.label }}</p>
          <p class="eventq-site-fields__value">{{ field.value }}</p>
        </div>
      }
    </div>
  </div>
}
